export default "__VITE_ASSET__933cec1b__"